export default "https://static-service.opploans-assets.com/assets/webpack/b45d1c126063c10a0fb25867794b55c1.png";